import Butter from "buttercms";
const butter = Butter("2b6cf23e34074307d4fcfea003a4e823ca6e07d6");

export default butter;
